import { View } from 'backbone.marionette';
import { Model } from 'backbone';
import template from './index.jst';
import './index.styl';

import { PriceReveal } from '../../collections';

import Preloader from '../../../../core/utils/Preloader';
import ErrorsModal from '../../../../core/utils/ErrorsModal';

class PriceRevealView extends View {

	get template() {
		return template;
	}

	get className() {
		return "price-reveal-page";
	}

	/**
	 *    Initialize view data
	 */
	async initialize() {
		this.model = new Model;
		this.price_reveal = new PriceReveal();

		this.model.set({
			squads_path: process.env.SQUAD_LOGOS_PATH,
			price_reveal: []
		});

		Preloader.show();
		try {
			await this.fetchData();
		}
		catch (e) {
			ErrorsModal.show([
				{
					text: "There was an error fetching the price reveal data" +
							", you will be unable to view revealed prices"
				}
			]);
		}
		this.updateModel()
			.updateView();

		Preloader.hide();
	}

	/**
	 *
	 * @returns {Promise.<Object>}
	 */
	fetchData() {
		return this.price_reveal.fetch();
	}

	/**
	 *
	 * @returns {PriceRevealView}
	 */
	updateModel() {
		this.model.set({
			price_reveal: this.price_reveal.toJSON()
		});

		return this;
	}

	/**
	 * Update view after all fetch data
	 */
	updateView() {
		this.render();
	}
}

export default PriceRevealView;